//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { medicalLiability } from "@/model/api/medical";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import  Details  from "./components/details.vue";   

import 'swiper/dist/css/swiper.css'
export default {
  name:'medicalResponsibility',
  data(){
    return {
      list:[],
      show:false,
      swiperOption:{
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        // centeredSlides: true,
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true
        //   }
      },
      data:{},
    }
  },
  computed: {
    hospitalId() {
      return this.$route.query.hospitalId
    }
  },
  created() {
    this.$loading.show()
    
    medicalLiability(this.hospitalId).then((data) => {
      // console.log('66',data)
      this.data = data;
      const arr = this.format(data) // 拿到保障内容列表
      const trueList = []
      const fasleList = []
      // 格式化列表顺序 true 在前 
      // 都为true的顺序 beautician_safeguards > hospital_safeguards > thirdparty_safeguards
      arr.forEach((item,index) =>{
        if(item.status){
          trueList.push(item)
        }else{
          fasleList.push(item)
        }
      })
      
      this.list = trueList.concat(fasleList)

      this.list.some(item=>{
        if(item.status){
          this.STATISTICS_CONFIG.insur_med_res_page({"ex":{hospital_id:this.hospitalId,type:item.type }})
        }
        return item.status
      })
    }).catch((err) => {
          this.$toast(err.message);         
    }).finally(()=>{
      this.$loading.hide()

    });

  },
  components: {
    Swiper,
    SwiperSlide,
    Details,
  },
  mounted() {
    // 禁用分享
      this.AppSetTitleBar('安心美',[]);
  },
  methods: {
    details(){

      this.STATISTICS_CONFIG.insur_med_res_effectinfo_click({"ex":{hospital_id:this.hospitalId }})
      this.show = false;
      this.$nextTick(()=>{
        this.show = true;
      })
    },
    pdf(pdfFlag){
      if(pdfFlag == 'beauty'){
        this.STATISTICS_CONFIG.insur_med_res_beauticianclause_click({"ex":{hospital_id:this.hospitalId }})
      }else if(pdfFlag == 'treatment'){
        this.STATISTICS_CONFIG.insur_med_res_hospitalclause_click({"ex":{hospital_id:this.hospitalId }})
      }

      this.$router.push({
          path: "/pdf",
          query:{
              insurFlag:'medical',
              pdfFlag:pdfFlag,
              flag : 'postdisable'
          }
      });
    },
    kefu(){
      this.STATISTICS_CONFIG.insur_med_res_contact_click({"ex":{hospital_id:this.hospitalId }})
    },
    format(data){  
      //  增加保障内容的 type 用于埋点 ，status 判断是否显示icon, img为保障内容图片
      const arr = [{
          key:'beautician_safeguards',
          status:data.beautician_safeguards,
          img:'https://static.soyoung.com/sy-pre/1@3x-1635923400681.png',
          type:2,
        },
        {
          key:'hospital_safeguards',
          status:data.hospital_safeguards,
          img:'https://static.soyoung.com/sy-pre/2@3x-1635923400681.png',
          type:1,
        },
        {
          key:'thirdparty_safeguards',
          status:data.thirdparty_safeguards,
          img:'https://static.soyoung.com/sy-pre/1usqq0jvfpsgu-1635923400681.png',
          type:3,
        },
      ]
      return arr
    }
  }
}
